const getAuthHeaders = () => ({
  "x-access-token": localStorage.getItem("jwtToken"),
});

export const authFetch = (url, options = {}) => {
  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      ...getAuthHeaders(),
    },
  });
};
